module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded && !_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Exclusão de GRV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao excluir GRV")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Excluído com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Atenção! Esta GRV está ligada aos seguintes itens:")]), _vm._v(" "), _c('small', [_vm._v("Os itens abaixo serão excluídos do sistema. "), _c('strong', {
    staticClass: "text-danger text-uppercase"
  }, [_vm._v("Esta operação não pode ser desfeita")])]), _vm._v(" "), _c('div', {
    staticClass: "row m-t-lg"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x lista-efeitos-colaterais"
  }, [_c('li', [_vm._v(_vm._s(_vm.data.fotos) + " Foto" + _vm._s(_vm.data.fotos !== 1 && 's' || ''))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.equipamentos) + " Equipamento" + _vm._s(_vm.data.equipamentos !== 1 && 's' || ''))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.lacres) + " Lacre" + _vm._s(_vm.data.lacres !== 1 && 's' || ''))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.atendimentos) + " Atendimento" + _vm._s(_vm.data.atendimentos !== 1 && 's' || ''))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.notificacoes_telegrama) + " Notificaç" + _vm._s(_vm.data.notificacoes_telegrama !== 1 && 'ões' || 'ão') + " de Telegrama")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x lista-efeitos-colaterais"
  }, [_c('li', [_vm._v(_vm._s(_vm.data.transferencias) + " Transferência" + _vm._s(_vm.data.transferencias !== 1 && 's' || '') + " de Pátio")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.historicosLocalizacao) + " Histórico" + _vm._s(_vm.data.historicosLocalizacao !== 1 && 's' || '') + " de Localização")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.pericia ? 'Possui' : 'Não possui') + " Perícia")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.preretiradas) + " Pré-retirada" + _vm._s(_vm.data.preretiradas !== 1 && 's' || ''))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.data.ggv ? 'Possui' : 'Não possui') + " GGV")])])])]), _vm._v(" "), (_vm.data.tasks.length) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.data.tasks.length) ? _c('h4', {
    staticClass: "m-b-lg"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle text-danger"
  }), _vm._v(" Esta GRV possui as seguintes tasks:")]) : _vm._e(), _vm._v(" "), (_vm.data.tasks.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x"
  }, _vm._l((_vm.data.tasks), function(task) {
    return _c('li', [_vm._v("Task #" + _vm._s(task.id) + ": " + _vm._s(task.description) + " ("), _c('small', [_vm._v(_vm._s(task.executed ? 'executada' : 'não executada'))]), _vm._v(")")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('h4', {
    staticClass: "m-b-lg"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle text-danger"
  }), _vm._v(" Esta GRV está ligada aos seguintes leilões:")]) : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x"
  }, _vm._l((_vm.data.lotes), function(lote) {
    return _c('li', [_vm._v("Lote "), _c('strong', [_vm._v(_vm._s(lote.lote))]), _vm._v(" no leilão "), _c('strong', [_vm._v(_vm._s(lote.tituloLeilao))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.impedirExclusao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.motivoExclusao),
      expression: "motivoExclusao",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "rows": "4",
      "placeholder": "Motivo da exclusão"
    },
    domProps: {
      "value": (_vm.motivoExclusao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivoExclusao = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.impedirExclusao) ? _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-auto btn-danger m-r-xs",
    attrs: {
      "disabled": _vm.isSemMotivo
    },
    on: {
      "click": _vm.deleteGrv
    }
  }, [_c('span', [_vm._v("Confirmar exclusão")])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1) : _c('div', {
    staticClass: "row wrapper"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('div', [_vm._v("Esta GRV não pode ser excluída, pois:")]), _vm._v(" "), _c('ul', [(_vm.data.lotes.length) ? _c('li', [_vm._v("Está relacionada a lotes")]) : _vm._e(), _vm._v(" "), (_vm.data.retirado) ? _c('li', [_vm._v("Veículo foi retirado")]) : _vm._e(), _vm._v(" "), (_vm.data.transmitido.length) ? _c('li', [_vm._v("\n                  Já foi transmitida para a DETRO\n                  "), _c('ul', _vm._l((_vm.data.transmitido), function(transmissao) {
    return _c('li', [_vm._v(_vm._s(transmissao.description))])
  }), 0)]) : _vm._e()])])])])])])]) : (_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x text-success"
  }), _vm._v(" "), _c('h4', {
    staticClass: "m-t-lg"
  }, [_vm._v("Grv excluída com sucesso!")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae51f5e8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/ExcluirGrvAlerta.vue
// module id = 2198
// module chunks = 2